import React, {Component} from 'react';
import { getCachedImageUrl } from '../services/image-cache';

export default class Credits extends Component {
    render(){
        let {credits, isFilm, producerIcon} = this.props

        let className = isFilm ? "film-credits" :"album-credits"

        return (
            <div className={className}>
              {
                  credits.map(({title, credits}, idx)=>{
                      const isProducedBy = title && title.toLowerCase().includes('produced');
                      return (
                          <div className="section" key={idx}>
                            <div className="header">{title}</div>
                            <div className="content">{credits}</div>
                            {isProducedBy && producerIcon && (
                              <div className="producer-icon-field">
                                <img
                                  className="producer-icon-img"
                                  src={getCachedImageUrl(producerIcon)}
                                  alt=""
                                />
                              </div>
                            )}
                          </div>
                      );
                  })
              }
            </div>
        )
    }
}
